import { Alert, Flex } from "@mantine/core";
import type { RootRouter } from "@project/api";
import { IconBug } from "@tabler/icons-react";
import type { TRPCClientErrorLike } from "@trpc/client";

export const FullPageError: React.FC<{ error: Error | TRPCClientErrorLike<RootRouter> }> = ({ error }) => {
  return (
    <Flex
      pos="fixed"
      left={0}
      top={0}
      bottom={0}
      right={0}
      display="flex"
      align="center"
      justify="center"
      bg="gray.3"
    >
      <Alert variant="light" color="red" title="Something when wrong" icon={<IconBug size={48} />}>
        {error.message}
      </Alert>
    </Flex>
  );
};
